export default __webpack_public_path__ + "static/media/Plan Kalehe - Securite climatique et prevention des catastrophes naturelles.03c53214.pdf";